export const BASE_URL = {
  apiBase: process.env.REACT_APP_PRISM_API_BASE_URL || "https://api.prismprocure.ai/prism-api/v1",
  fileUpload: process.env.REACT_APP_PRISM_FILE_UPLOAD_BASE_URL,
  invoiceBase: process.env.REACT_APP_PRISM_PAYMENT_API_BASE_URL || "https://a4bgo47pqe.execute-api.ap-south-1.amazonaws.com/dev/prism-api/v1"
}

export const API_ENDPOINTS = {
  // Authentication Endpoints
  login: `${BASE_URL.apiBase}/authenticator/login`,
  verifyToken: `${BASE_URL.apiBase}/authenticator/verifyTokenV2`,
  partyResetAccountPassword: `${BASE_URL.apiBase}/party/resetAccountPassword`,
  forgotPasswordSendOtp: `${BASE_URL.apiBase}/party/forgotPassword/sendOtp`,
  forgotPasswordVerifyOtp: `${BASE_URL.apiBase}/party/forgotPassword/verifyOtp`,

  // Party Endpoints
  getPartyByPartyId: `${BASE_URL.apiBase}/party/:id`,

  // Order Endpoints
  getAllOrders: `${BASE_URL.apiBase}/order/getAll`,
  getOrderPdf: `${BASE_URL.apiBase}/order/generateOrderPdf`,
  updateOrderStatus: `${BASE_URL.apiBase}/order/:orderId/status-update`,

  // GRN Endpoints
  getAllGrn: `${BASE_URL.apiBase}/order/grn/getAll`,
  getGRNPDF: `${BASE_URL.apiBase}/order/grn/generateGrnPdf`,
  ackGRN: `${BASE_URL.apiBase}/order/grn/acknowledge`,

  // File Endpoints
  fileUpload: `${BASE_URL.fileUpload}/order/upload-document`,

  // Content Endpoints
  createOrderContent: `${BASE_URL.apiBase}/content/order/create`,
  fetchOrderContent: `${BASE_URL.apiBase}/content/order/:orderId/content`,
  createGRNContent: `${BASE_URL.apiBase}/content/grn/create`,
  fetchGRNContent: `${BASE_URL.apiBase}/content/grn/:goodsReqChallanId`,

  // Invoice Endpoints
  getInvoicePdf: `${BASE_URL.invoiceBase}/paymentInvoice/invoice/downloadPdf`,
  getAllInvoice: `${BASE_URL.invoiceBase}/paymentInvoice/invoice/searchInvoice`,


};

export const COOKIE_NAMES = {
  jwtToken: "jwtTokenBuyer",
  tokenExpiryTime: "tokenExpiryTimeBuyer",
  orgPartyName: "orgPartyNameBuyer",
  prismUser: "prismUserBuyer",
  subscription: "subscriptionBuyer"
};

export const DASHBOARD_CONSTANTS = {
  PAGE_SIZES: [10, 25, 50, 100],
  STATUS_FILTER: {
    ORDER: {
      DEFAULT: {
        id: "",
        name: ""
      },
      ALL: {
        id: "ALL",
        name: "All"
      },
      CREATED: {
        id: "ORDER_CREATED",
        name: "Created"
      },
      DRAFT: {
        id: "ORDER_DRAFT",
        name: "Draft"
      },
      PROCESSING: {
        id: "ORDER_PROCESSING",
        name: "Processing"
      },
      DELIVERED: {
        id: "ORDER_DELIVERED",
        name: "Delivered"
      },
      INVOICE_CREATED: {
        id: "INVOICE_CREATED",
        name: "Invoice created"
      },
      THREE_WAY_MATCH_APPROVED: {
        id: "ORDER_ACCEPTED",
        name: "Invoice Accepted"
      },
      REJECTED: {
        id: "ORDER_REJECTED",
        name: "Rejected"
      },
      CANCELLED: {
        id: "ORDER_CANCELLED",
        name: "Cancelled"
      },
      CLOSED: {
        id: "ORDER_CLOSED",
        name: "Closed"
      },
      COMPLETED: {
        id: "ORDER_COMPLETED",
        name: "Completed"
      },
      UPDATED: {
        id: "ORDER_UPDATED",
        name: "Updated"
      }
    },
    DELIVERY_CHALLAN: {
      Default: {
        id: "",
        name: ""
      },
      ALL: {
        id: "GRN_ALL",
        name: "All"
      },
      DRAFT: {
        id: "GRN_DRAFT",
        name: "Draft"
      },
      CREATED: {
        id: "GRN_CREATED",
        name: "Created"
      },
      DELIVERED: {
        id: "GRN_DELIVERED",
        name: "Delivered"
      },
      DISPATCHED: {
        id: "GRN_DISPATCHED",
        name: "Dispatched"
      },
      PENDING_ACK: {
        id: "GRN_PENDING_ACKNOWLEDGEMENT",
        name: "Pending Ack"
      }
    }
  },
  TABS: {
    ORDERS: "ORDERS",
    DELIVERY_CHALLANS: "DELIVERY_CHALLANS",
    INVOICES: "INVOICES"
  },
}

export const DATE_FILTERS = {
  TODAY: {
    name: "Today",
    value: "TODAY",
  },
  WEEK: {
    name: "This Week",
    value: "WEEK",
  },
  MONTH: {
    name: "This Month",
    value: "MONTH",
  },
  YEAR: {
    name: "This Year",
    value: "YEAR",
  },
  CUSTOM: {
    name: "Custom Range",
    value: "CUSTOM",
  },
  ALL: {
    name: "All",
    value: "ALL",
  }
}

export const DATE_FORMAT = {
  ISO_FORMAT: "DD-MM-YYYY",
  DB_FORMAT: "",
  TIME_FORMAT: "HH:mm",
};

export const DEVICE_TYPES = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
}

export const PAGES_URL = {
  // HOME URLS
  DASHBOARD: "/dashboard",
  HOME: "/home",
  SIGN_IN: "/signin",

  // ORDER URLS
  ORDER_MGR: "/order",

  // GRN URLS
  GRN_MGR: "/grn",

  // INVOICE URLS
  INVOICE_MGR: "/invoice"
}

export const PARTY_STATUS = {
  ACTIVE: "PARTY_ACTIVE",
  INACTIVE: "PARTY_IN_ACTIVE",
}

export const REGEX = {
  inputStringGeneralCharacters: /^[a-zA-Z0-9.,_\-\s/\\:]+$/,
  decimalValue: /^-?\d+(\.\d+)?$/,
  noSpecialCharactersInput: /^[a-zA-Z0-9 ]*$/, // Regular expression to match alphanumeric characters and whitespace
};

export const SOURCE = {
  RECEIVEAPP : "RECEIVEAPP"
}

export const STATUS = {
  PAYMENT_STATUS : {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    UPLOADED: "UPLOADED",
  },
  THREE_WAY_MATCH_STATUS: {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED"
  },
  ORDER: {
    ORDER_APPROVED: {
      id: "ORDER_APPROVED",
      name: "Approved"
    },
    ORDER_DRAFT: {
      id: "ORDER_DRAFT",
      name: "Draft"
    },
    ORDER_CREATED: {
      id: "ORDER_CREATED",
      name: "Created"
    },
    ORDER_CLOSED: {
      id: "ORDER_CLOSED",
      name: "Closed"
    },
    ORDER_REJECTED: {
      id: "ORDER_REJECTED",
      name: "Rejected"
    },
    ORDER_CANCELLED: {
      id: "ORDER_CANCELLED",
      name: "Cancelled"
    },
    ORDER_PROCESSING: {
      id: "ORDER_PROCESSING",
      name: "Processing"
    },
    ORDER_DELIVERED: {
      id: "ORDER_DELIVERED",
      name: "Delivered"
    },
    INVOICE_CREATED: {
      id: "INVOICE_CREATED",
      name: "Invoice created"
    },
    THREE_WAY_MATCH_APPROVED: {
      id: "THREE_WAY_MATCH_APPROVED",
      name: "Invoice Accepted"
    },
    THREE_WAY_MATCH_REJECTED: {
      id: "THREE_WAY_MATCH_REJECTED",
      name: "3 way match rejected"
    },
    PAYMENT_APPROVED: {
      id: "PAYMENT_APPROVED",
      name: "Payment approved"
    },
    ORDER_SUBMITTED: {
      id: "ORDER_SUBMITTED",
      name: "Submitted"
    },
    ORDER_INTRANSIT: {
      id: "ORDER_INTRANSIT",
      name: "Intransit"
    },
    ORDER_DELAYED: {
      id: "ORDER_DELAYED",
      name: "Delayed"
    },
    ORDER_ACCEPTED: {
      id: "ORDER_ACCEPTED",
      name: "Invoice Accepted"
    },
    ORDER_COMPLETED: {
      id: "ORDER_COMPLETED",
      name: "Completed"
    },
    PAYMENT_REJECTED: {
      id: "PAYMENT_REJECTED",
      name: "Payment rejected"
    },
    ORDER_UPDATED: {
      id: "ORDER_UPDATED",
      name: "Updated"
    }
  },
  GRN: {
    GRN_DRAFT: {
      id: "GRN_DRAFT",
      name: "Draft"
    },
    GRN_CREATED: {
      id: "GRN_CREATED",
      name: "Created"
    },
    GRN_DELIVERED: {
      id: "GRN_DELIVERED",
      name: "Delivered"
    },
    GRN_DISPATCHED: {
      id: "GRN_DISPATCHED",
      name: "Dispatched"
    },
    GRN_REJECTED: {
      id: "GRN_REJECTED",
      name: "Rejected"
    },
    GRN_PENDING_ACKNOWLEDGEMENT: {
      id: "GRN_PENDING_ACKNOWLEDGEMENT",
      name: "Pending Ack"
    },
    API_DELIVERED: {
      id: "API_DELIVERED",
      name: "GRN_DELIVERED"
    },
    API_REJECTED: {
      id: "API_REJECTED",
      name: "GRN_REJECTED"
    },
    API_CREATED: {
      id: "API_CREATED",
      name: "GRN_CREATED"
    },
    API_PENDING_ACKNOWLEDGEMENT: {
      id: "API_PENDING_ACKNOWLEDGEMENT",
      name: "GRN_PENDING_ACKNOWLEDGEMENT"
    }
  }
}

export const SUBSCRIPTION_INTERVAL = {
  YEARLY: "YEARLY",
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  FREE_TIER: "2025-09-30T23:59:59"
}

export const UPLOAD_FILE_CONTENT_NAME = {
  SIGNED_DELIVERY_CHALLAN: "Signed Delivery Challan",
  SIGNED_INVOICE: "Signed Invoice",
  SIGNED_PO: "Signed Purchase Order"
};

export const UPLOAD_FILE_CONTENT_TYPE = {
  IMAGE: "IMAGE_OBJECT",
  INVOICE: "Invoice",
  DOCUMENT: "DOCUMENT",
};

export const UPLOAD_FILE_PURPOSE_TYPE = {
  SIGNED_DELIVERY_CHALLAN: "SIGNED_DELIVERY_CHALLAN",
  SIGNED_INVOICE: "SIGNED_INVOICE",
  SIGNED_PO: "SIGNED_PO"
};